import { flagFromEnv } from './envFlag';
import { EnvironmentDescriptor } from './types';

export const engineeringEnvironment: EnvironmentDescriptor = {
  id: 'engineering',
  translationNamespaces: ['common', 'engineering'],
  featureFlags: {
    invoices: false,
    outlookSync: false,
    engineeringTemplates: true,
    // Bids / estimating — PER-CLIENT, from the build environment rather than hardcoded here.
    //
    // Not every engineering client wants a construction estimator, and SEPT ships a separate
    // frontend build per client, so this has to be a build variable: hardcoding `true` meant the
    // only way to hide it from one client was to edit this file, which is a code change for a
    // deployment decision.
    //
    // DEFAULT OFF — a client gets Bid Sheets only by asking for it. The other default was
    // considered and rejected: defaulting on means a client who never asked for an estimator finds
    // one in their nav after a routine deploy, and the failure is silent. With this default, a
    // build that forgets the variable shows no Bid Sheets — wrong, but visibly and recoverably so.
    //
    // Turning it on: REACT_APP_FEATURE_BIDS=true at BUILD time (baked in by CRA; setting it at
    // runtime does nothing). The e2e harness and `npm run sept:frontend` both set it, because the
    // bid specs would otherwise pass against an app with no bids in it.
    //
    // This gates UI only. The backend `/bids` routes register wherever the migrations have run and
    // are protected by bid roles (`bid_role_assignments`), not by this flag — so an operator who
    // wants the feature genuinely dark for a client should also leave that client's roles
    // unassigned, which makes every mutation and every dollar 403 regardless of the build.
    bids: flagFromEnv('REACT_APP_FEATURE_BIDS', process.env.REACT_APP_FEATURE_BIDS, false),
    // Weekday locks + time requests on the engineering timesheet grids
    // (plans/todo/timesheet-day-locks.md). The server guard runs on DATA, not this flag: with no
    // locked weekdays it does nothing, so the flag only decides whether the lock / request UI renders.
    timesheetDayLocks: true,
  },
  componentVisibility: {
    profileWorkflow: false,
    engineeringTemplates: true,
  },
};
